import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";

/**
 * Reusable table skeleton. Defaults to showing the loader so
 * `<PreloaderTable />` works without an explicit `isLoading` prop.
 */
const PreloaderTable = ({
  isLoading = true,
  columns = 6,
  rows = 7,
  className = "",
}) => {
  if (!isLoading) return null;

  const colKeys = Array.from({ length: Math.max(1, columns) }, (_, i) => i);
  const rowKeys = Array.from({ length: Math.max(1, rows) }, (_, i) => i);

  return (
    <Paper className={className} elevation={0}>
      <TableContainer>
        <Table size="small">
          <TableHead className="bg-light">
            <TableRow>
              {colKeys.map((col) => (
                <TableCell key={`h-${col}`}>
                  <Skeleton variant="text" width={col === 0 ? 40 : "70%"} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowKeys.map((row) => (
              <TableRow
                key={`r-${row}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {colKeys.map((col) => (
                  <TableCell key={`c-${row}-${col}`}>
                    <Skeleton
                      variant="text"
                      width={col === 0 ? 24 : col === colKeys.length - 1 ? 72 : "80%"}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PreloaderTable;
